import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { translationPropType } from '@eb/i18n';
import isEmpty from 'lodash/isEmpty';

import { EventActionBarWithOutHOC as EventPageActionBar } from '@eb/event-create-primitives';

import transform from '../transform';
import defaultSettings from './settings';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
import EventsConflicts from '../../components/downgradeConflicts/EventsConflicts';
import Heading from '../../components/Heading';
import {
    CONFLICTS_TRANSLATIONS,
    DEFAULT_PAGE_NUMBER,
    PAGE_CONFLICTS_PROP_TYPES,
} from '../../constants/downgrade';
import { transformDowngradeConflicts } from './transformation';

import './page.scss';

export default class ConfirmConflictPlanChangePage extends PureComponent {
    static propTypes = {
        isPackageChangeDowngradeEnabled: PropTypes.bool.isRequired,
        onRedirectToDowngrade: PropTypes.func.isRequired,
        changePackageCTA: translationPropType.isRequired,
        keepPackageCTA: translationPropType.isRequired,
        onChangePackage: PropTypes.func.isRequired,
        onKeepPackage: PropTypes.func.isRequired,
        onPageChange: PropTypes.func.isRequired,
        conflicts: PAGE_CONFLICTS_PROP_TYPES,
        isConflictsLoading: PropTypes.bool,
    };

    constructor(props) {
        super(props);

        this.state = {
            currentPage: DEFAULT_PAGE_NUMBER,
            conflicts: transformDowngradeConflicts(
                props.conflicts,
                DEFAULT_PAGE_NUMBER,
            ),
        };
    }

    componentDidMount() {
        const {
            isPackageChangeDowngradeEnabled,
            onRedirectToDowngrade,
            conflicts,
        } = this.props;

        if (!isPackageChangeDowngradeEnabled || isEmpty(conflicts)) {
            return onRedirectToDowngrade();
        }
    }

    _handlePageChange = async (page = DEFAULT_PAGE_NUMBER) => {
        const { conflicts, onPageChange } = this.props;

        this.setState({
            conflicts:
                transformDowngradeConflicts(conflicts, page) ||
                transformDowngradeConflicts(await onPageChange(page)),
            currentPage: page,
        });
    };

    render() {
        const {
            isPackageChangeDowngradeEnabled,
            changePackageCTA,
            keepPackageCTA,
            onChangePackage,
            onKeepPackage,
            isConflictsLoading = false,
        } = this.props;
        const { conflicts } = this.state;

        if (!isPackageChangeDowngradeEnabled || isEmpty(conflicts)) {
            return null;
        }
        const {
            breadcrumbs: { crumbs },
        } = transform({ defaultSettings });

        return (
            <div
                className="conflicts-container"
                data-spec="downgrade-conflicts-container"
            >
                <HeaderBreadcrumbs crumbs={crumbs} />
                <div className="eds-g-grid eds-l-pad-bot-20 eds-l-sm-mar-bot-20 marketing-container__max-width">
                    <Heading
                        {...CONFLICTS_TRANSLATIONS.header(
                            conflicts.pagination.objectCount,
                        )}
                    />
                    <EventsConflicts
                        conflicts={conflicts}
                        onPageChange={this._handlePageChange}
                        isLoading={isConflictsLoading}
                    />
                </div>
                <div className="conflicts-container__bar">
                    <EventPageActionBar
                        visible={true}
                        onDiscard={onKeepPackage}
                        onSave={onChangePackage}
                        submitText={changePackageCTA}
                        discardText={keepPackageCTA}
                    />
                </div>
            </div>
        );
    }
}
